export const STAR_COUNT = 5;

export type ScorePerformanceBand = 'excellent' | 'good' | 'average' | 'poor';

/**
 * Maps a mission score (0-100) to a 0-5 star rating.
 */
export const getStarRating = (rawScore: number): number => {
  const score = Math.max(0, Math.min(100, rawScore));

  if (score >= 95) return 5;
  if (score >= 80) return 4;
  if (score >= 60) return 3;
  if (score >= 40) return 2;
  if (score > 0) return 1;
  return 0;
};

/**
 * Maps a mission score (0-100) to a display performance band.
 */
export const getScorePerformanceBand = (rawScore: number): ScorePerformanceBand => {
  const score = Math.max(0, Math.min(100, rawScore));

  if (score >= 90) return 'excellent';
  if (score >= 70) return 'good';
  if (score >= 50) return 'average';
  return 'poor';
};

/**
 * Converts a camelCase skill key into a display label.
 * Example: basicMoves -> Basic Moves
 */
export const formatSkillLabel = (skillKey: string): string => {
  if (!skillKey) return '';
  return skillKey.charAt(0).toUpperCase() + skillKey.slice(1).replace(/([A-Z])/g, ' $1');
};
